import { Component, OnInit } from '@angular/core';
import * as Enum from '../utils/enums'
import { Loading } from '../utils/loading';
import { RequestBuilder } from '../classes/request-builder';
import { finalize } from 'rxjs/operators';
import * as Moment from 'moment';
import { ScadenzarioService } from '../services/scadenzario.service';
import { AlertUtil } from '../utils/alert-util';
import { StoricoModuloService } from '../services/storicomodulo.service';
import { IDocumento } from '../interfaces/IDocumento';
import { IStoricoRisposte } from '../interfaces/IStoricoRisposte';
import { DialogService } from 'primeng/api';
import { DocumentoModalComponent } from '../documento-modal/documento-modal.component';

@Component({
  selector: 'app-scadenzario',
  templateUrl: './scadenzario.component.html',
  styleUrls: ['./scadenzario.component.css']
})
export class ScadenzarioComponent implements OnInit {
  documenti: IDocumento[]  // table data source
  DTT = Enum.DATA_TABLE_TYPE_ENUM //export enum for html
  rowSelected: boolean = false    //determines whether one scadenzario row has been clicked
  documento: IDocumento
  documentoSelected: IDocumento // documento selected from table

  constructor(private scadenzarioService: ScadenzarioService, private alertUtil: AlertUtil,
    private storicoModuloService: StoricoModuloService, private dialogService: DialogService) { }

  ngOnInit() {
    setTimeout(() => {
      this.getAllScadenzari()
    }, 0);
  }

  /**
   * get all scadenzari
   */
  getAllScadenzari() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({})
    this.scadenzarioService.getAllScadenzario(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.documenti = response.data
          this.calculateScadenzarioState()
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }


  /**
   * calculate state of documento
   */
  calculateScadenzarioState() {
    this.documenti.forEach(documento => {
      if (documento.Data_scadenza) {
        if (documento.Giorni_preavviso == null) {
          documento.Giorni_preavviso = "30"
        }
        let dataScadenza = Moment(documento.Data_scadenza);//data scadenza from documento
        let dataPreavviso = Moment(documento.Data_scadenza).subtract(documento.Giorni_preavviso, 'days'); //calculate data Preavviso
        let now = Moment() // data now
        if (now.isAfter(dataScadenza)) {
          documento.Stato = Enum.SCADENZARIO_STATE_ENUM.SCADUTO
        } else if (now.isBefore(dataPreavviso)) {
          documento.Stato = Enum.SCADENZARIO_STATE_ENUM.VALIDO
        } else {
          documento.Stato = Enum.SCADENZARIO_STATE_ENUM.IN_SCADENZA
        }
      }
      else {
        documento.Stato = Enum.SCADENZARIO_STATE_ENUM.VALIDO
      } 
    })
  }

  onRowSelected(documentoSelected: IDocumento) {
    this.documento = documentoSelected
    this.callStoricoModuloFetchSingle()

  }

  onRowUnselected() {
    this.rowSelected = false
    this.documento = null
  }

  /**
   * call storicoModulo fetch single
   */
  callStoricoModuloFetchSingle() {
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder({
      Id: this.documento.Id,
      Version: null
    })
    this.storicoModuloService.storicoModuloFetchSingle(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.documentoSelected = response.data
          this.createCustomResponse()
          this.openDocumentoModal(this.documentoSelected)
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * read documento Selected and set Risposta Custom for all questions
   */
  createCustomResponse() {
    let storicoRisposte = this.documentoSelected.StoricoRisposte //get storico risposte array
    let matrDomande = this.documentoSelected.MatriceModulo.MatriceDomande //get matrice domande array
    if (matrDomande) {
      for (let i = 0; i < matrDomande.length; i++) { // iterate matrice domande
        let matriceDomanda = matrDomande[i]
        if (storicoRisposte) {
          for (let y = 0; y < storicoRisposte.length; y++) { // iterate storico risposte
            let storicoRisp = storicoRisposte[y]
            if (storicoRisp.Domanda_Id == matriceDomanda.Id) { // if answer for this question set rispostaCustom to matrice domanda
              matriceDomanda.RispostaCustom = storicoRisp
              break;
            }
          }
          if (!matriceDomanda.RispostaCustom) { // if matrice domanda has no risposta custom set empty risposta
            let storicoEmpty: IStoricoRisposte = {
              Domanda_Id: matriceDomanda.Id,
              Valore: null,
              Placeholder: null,
              Valido: null
            }
            matriceDomanda.RispostaCustom = storicoEmpty
          }
        }
      }
    }
  }

  /**
   * open documento modal
   * @param documento 
   */
  openDocumentoModal(documento: IDocumento) {
    //open aggiudicatari modal
    this.dialogService.open(DocumentoModalComponent, {
      data: { documento, richiesta: documento.Richiesta, fromScadenzario: true },
      header: documento.Nome,
      width: '80%'
    })
  }

}
